// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__2f53J","error":"Textarea_error__3c1Wq","readonly":"Textarea_readonly__3uz3g","disabled":"Textarea_disabled__Ny5QH"};